import BaseTextField from "components/base/TextField"
import useInput from "hooks/use_input"
import BaseMask from "../../base/Mask"
import useTranslation from "../../../hooks/use_translation"

const EmailConfirmationCode = () => {
  const id = "email_confirmation_code"
  const { fields } = useTranslation()

  const validate = (value) => {
    if (value === "") return "This field is required"
    if (value.length < 6) return "Code is to short. Please enter 6 digits"

    return ""
  }

  const { handleChange, inputValue, errorMessage, handleBlur } = useInput(id, validate)

  return (
    <BaseTextField
      id={id}
      _label={fields?.email_code_title}
      value={inputValue}
      onChange={handleChange}
      error={errorMessage?.length > 0}
      onBlur={handleBlur}
      helperText={errorMessage}
      InputProps={{
        inputComponent: BaseMask,
        inputProps: {
          mask: /^[a-zA-Z\d]{0,6}$/,
        },
      }}
    />
  )
}

export default EmailConfirmationCode
